__turbopack_context__.v({
  "controlButtons": "tiwMJG_controlButtons",
  "controls": "tiwMJG_controls",
  "header": "tiwMJG_header",
  "productWrapper": "tiwMJG_productWrapper",
  "redirectTile": "tiwMJG_redirectTile",
  "seeMore": "tiwMJG_seeMore",
  "sliderWrapper": "tiwMJG_sliderWrapper",
  "title": "tiwMJG_title",
});
